module.exports = __webpack_public_path__ + "static/media/web-based-real2.2dbcb93f.png";